/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParticipantRelationship } from './ParticipantRelationship';
import {
    ParticipantRelationshipFromJSON,
    ParticipantRelationshipFromJSONTyped,
    ParticipantRelationshipToJSON,
    ParticipantRelationshipToJSONTyped,
} from './ParticipantRelationship';

/**
 * 
 * @export
 * @interface ParticipantInput
 */
export interface ParticipantInput {
    /**
     * 
     */
    display_name: string;
    /**
     * 
     */
    relationship: ParticipantRelationship;
    /**
     * 
     */
    email: string;
    /**
     * Shown to staff only; never used to send in v1
     */
    phone?: string | null;
    /**
     * Staff confirms the email belongs to this person
     */
    contact_confirmed: boolean;
}



/**
 * Check if a given object implements the ParticipantInput interface.
 */
export function instanceOfParticipantInput(value: object): value is ParticipantInput {
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    if (!('relationship' in value) || value['relationship'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('contact_confirmed' in value) || value['contact_confirmed'] === undefined) return false;
    return true;
}

export function ParticipantInputFromJSON(json: any): ParticipantInput {
    return ParticipantInputFromJSONTyped(json, false);
}

export function ParticipantInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantInput {
    if (json == null) {
        return json;
    }
    return {
        
        'display_name': json['display_name'],
        'relationship': ParticipantRelationshipFromJSON(json['relationship']),
        'email': json['email'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'contact_confirmed': json['contact_confirmed'],
    };
}

export function ParticipantInputToJSON(json: any): ParticipantInput {
    return ParticipantInputToJSONTyped(json, false);
}

export function ParticipantInputToJSONTyped(value?: ParticipantInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'display_name': value['display_name'],
        'relationship': ParticipantRelationshipToJSON(value['relationship']),
        'email': value['email'],
        'phone': value['phone'],
        'contact_confirmed': value['contact_confirmed'],
    };
}

